import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoteFailedIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Hubs",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M-13724 -4781H5121V-4801H-13724V-4781ZM5113 -4789V7783H5133V-4789H5113ZM5121 7775H-13724V7795H5121V7775ZM-13716 7783V-4789H-13736V7783H-13716ZM-13724 7775C-13719.6 7775 -13716 7778.58 -13716 7783H-13736C-13736 7789.63 -13730.6 7795 -13724 7795V7775ZM5113 7783C5113 7778.58 5116.58 7775 5121 7775V7795C5127.63 7795 5133 7789.63 5133 7783H5113ZM5121 -4781C5116.58 -4781 5113 -4784.58 5113 -4789H5133C5133 -4795.63 5127.63 -4801 5121 -4801V-4781ZM-13724 -4801C-13730.6 -4801 -13736 -4795.63 -13736 -4789H-13716C-13716 -4784.58 -13719.6 -4781 -13724 -4781V-4801Z",
				fill: "black",
				fillOpacity: .1
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Modal - Edit note error",
				children: [/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#clip0_5108_8805)",
					children: [/* @__PURE__ */ _jsx("rect", {
						x: -120,
						y: -80,
						width: 440,
						height: 428,
						rx: 12,
						fill: "white"
					}), /* @__PURE__ */ _jsx("g", {
						id: "Content",
						children: /* @__PURE__ */ _jsx("g", {
							id: "create profile",
							children: /* @__PURE__ */ _jsx("g", {
								id: "create profile_2",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Add Hub owner details",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Verify",
										children: /* @__PURE__ */ _jsx("g", {
											id: "M-Empty State",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Content_2",
												children: /* @__PURE__ */ _jsxs("g", {
													id: "Note added error",
													children: [/* @__PURE__ */ _jsx("g", {
														id: "Group 300",
														children: /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle 3464110",
															width: 200,
															height: 140,
															fill: "white"
														})
													}), /* @__PURE__ */ _jsxs("g", {
														id: "Group 631670",
														children: [
															/* @__PURE__ */ _jsx("path", {
																id: "Vector 1125",
																d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
																fill: "#F0FAF8"
															}),
															/* @__PURE__ */ _jsx("circle", {
																id: "Ellipse 592",
																cx: 89.6406,
																cy: 120.66,
																r: 6,
																fill: "#F0FAF8"
															}),
															/* @__PURE__ */ _jsx("circle", {
																id: "Ellipse 593",
																cx: 40.6406,
																cy: 35.6602,
																r: 8,
																fill: "#F0FAF8"
															}),
															/* @__PURE__ */ _jsxs("g", {
																id: "Group 631664",
																children: [
																	/* @__PURE__ */ _jsx("path", {
																		id: "Vector",
																		d: "M64 46V106C64 112.619 69.3813 118 76 118H124C130.619 118 136 112.619 136 106V46C136 39.3813 130.619 34 124 34H114.7C114.737 34.15 114.756 34.3 114.775 34.4313C118.394 35.6125 121 39.0063 121 43V47.5C121 49.9937 118.994 52 116.5 52H100H83.5C81.0063 52 79 49.9937 79 47.5V43C79 39.0063 81.6062 35.6125 85.225 34.4313C85.2437 34.2813 85.2812 34.1312 85.3 34H76C69.3813 34 64 39.3813 64 46ZM86.5 73C86.5 74.1935 86.0259 75.3381 85.182 76.182C84.3381 77.0259 83.1935 77.5 82 77.5C80.8065 77.5 79.6619 77.0259 78.818 76.182C77.9741 75.3381 77.5 74.1935 77.5 73C77.5 71.8065 77.9741 70.6619 78.818 69.818C79.6619 68.9741 80.8065 68.5 82 68.5C83.1935 68.5 84.3381 68.9741 85.182 69.818C86.0259 70.6619 86.5 71.8065 86.5 73ZM86.5 91C86.5 92.1935 86.0259 93.3381 85.182 94.182C84.3381 95.0259 83.1935 95.5 82 95.5C80.8065 95.5 79.6619 95.0259 78.818 94.182C77.9741 93.3381 77.5 92.1935 77.5 91C77.5 89.8065 77.9741 88.6619 78.818 87.818C79.6619 86.9741 80.8065 86.5 82 86.5C83.1935 86.5 84.3381 86.9741 85.182 87.818C86.0259 88.6619 86.5 89.8065 86.5 91ZM94 73C94 71.35 95.35 70 97 70H121C122.65 70 124 71.35 124 73C124 74.65 122.65 76 121 76H97C95.35 76 94 74.65 94 73ZM94 91C94 89.35 95.35 88 97 88H121C122.65 88 124 89.35 124 91C124 92.65 122.65 94 121 94H97C95.35 94 94 92.65 94 91Z",
																		fill: "url(#paint0_linear_5108_8805)"
																	}),
																	/* @__PURE__ */ _jsx("path", {
																		id: "Vector_2",
																		d: "M85.225 34.4312C86.425 27.3813 92.5937 22 100 22C107.406 22 113.575 27.3813 114.775 34.4312C118.394 35.6125 121 39.0062 121 43V47.5C121 49.9937 118.994 52 116.5 52H100H83.5C81.0062 52 79 49.9937 79 47.5V43C79 39.0062 81.6062 35.6125 85.225 34.4312ZM104.5 37C104.5 35.8065 104.026 34.6619 103.182 33.818C102.338 32.9741 101.193 32.5 100 32.5C98.8065 32.5 97.6619 32.9741 96.818 33.818C95.9741 34.6619 95.5 35.8065 95.5 37C95.5 38.1935 95.9741 39.3381 96.818 40.182C97.6619 41.0259 98.8065 41.5 100 41.5C101.193 41.5 102.338 41.0259 103.182 40.182C104.026 39.3381 104.5 38.1935 104.5 37ZM77.5 73C77.5 71.8065 77.9741 70.6619 78.818 69.818C79.6619 68.9741 80.8065 68.5 82 68.5C83.1935 68.5 84.3381 68.9741 85.182 69.818C86.0259 70.6619 86.5 71.8065 86.5 73C86.5 74.1935 86.0259 75.3381 85.182 76.182C84.3381 77.0259 83.1935 77.5 82 77.5C80.8065 77.5 79.6619 77.0259 78.818 76.182C77.9741 75.3381 77.5 74.1935 77.5 73ZM77.5 91C77.5 89.8065 77.9741 88.6619 78.818 87.818C79.6619 86.9741 80.8065 86.5 82 86.5C83.1935 86.5 84.3381 86.9741 85.182 87.818C86.0259 88.6619 86.5 89.8065 86.5 91C86.5 92.1935 86.0259 93.3381 85.182 94.182C84.3381 95.0259 83.1935 95.5 82 95.5C80.8065 95.5 79.6619 95.0259 78.818 94.182C77.9741 93.3381 77.5 92.1935 77.5 91Z",
																		fill: "url(#paint1_linear_5108_8805)"
																	}),
																	/* @__PURE__ */ _jsxs("g", {
																		id: "Fill/Alert",
																		children: [/* @__PURE__ */ _jsx("path", {
																			id: "Vector_3",
																			d: "M149.333 57C149.333 64.3638 143.364 70.3333 136 70.3333C128.636 70.3333 122.667 64.3638 122.667 57C122.667 49.6362 128.636 43.6666 136 43.6666C143.364 43.6666 149.333 49.6362 149.333 57Z",
																			fill: "#DB5543",
																			stroke: "white",
																			strokeWidth: 1.5,
																			strokeLinecap: "round"
																		}), /* @__PURE__ */ _jsx("path", {
																			id: "Vector 1143 (Stroke)",
																			fillRule: "evenodd",
																			clipRule: "evenodd",
																			d: "M136 49.3334C136.552 49.3334 137 49.7811 137 50.3334V58.3334C137 58.8857 136.552 59.3334 136 59.3334C135.448 59.3334 135 58.8857 135 58.3334V50.3334C135 49.7811 135.448 49.3334 136 49.3334ZM136 61.3334C136.552 61.3334 137 61.7811 137 62.3334V63.6667C137 64.219 136.552 64.6667 136 64.6667C135.448 64.6667 135 64.219 135 63.6667V62.3334C135 61.7811 135.448 61.3334 136 61.3334Z",
																			fill: "white"
																		})]
																	})
																]
															}),
															/* @__PURE__ */ _jsx("path", {
																id: "Line 3",
																d: "M97 73H121",
																stroke: "url(#paint2_linear_5108_8805)",
																strokeWidth: 6,
																strokeLinecap: "round"
															}),
															/* @__PURE__ */ _jsx("path", {
																id: "Line 4",
																d: "M97 91H121",
																stroke: "url(#paint3_linear_5108_8805)",
																strokeWidth: 6,
																strokeLinecap: "round"
															}),
															/* @__PURE__ */ _jsx("path", {
																id: "Ellipse 600",
																d: "M105 37C105 39.7614 102.761 42 100 42C97.2386 42 95 39.7614 95 37C95 34.2386 97.2386 32 100 32C102.761 32 105 34.2386 105 37Z",
																fill: "url(#paint4_linear_5108_8805)"
															})
														]
													})]
												})
											})
										})
									})
								})
							})
						})
					})]
				}), /* @__PURE__ */ _jsx("rect", {
					x: -119.5,
					y: -79.5,
					width: 439,
					height: 427,
					rx: 11.5,
					stroke: "#D4D4D4"
				})]
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_5108_8805",
				x1: 100,
				y1: 34,
				x2: 100,
				y2: 118,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_5108_8805",
				x1: 99.25,
				y1: 22,
				x2: 99.25,
				y2: 95.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5108_8805",
				x1: 97,
				y1: 73.5,
				x2: 121,
				y2: 73.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_5108_8805",
				x1: 97,
				y1: 91.5,
				x2: 121,
				y2: 91.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_5108_8805",
				x1: 100,
				y1: 32,
				x2: 100,
				y2: 42,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_5108_8805",
				children: /* @__PURE__ */ _jsx("rect", {
					x: -120,
					y: -80,
					width: 440,
					height: 428,
					rx: 12,
					fill: "white"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNoteFailedIcon);
export { ForwardRef as ReactComponent };
